import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Prebooking from "../types/Prebooking";
import {ME_BASE_URL} from "../../../config/config";

type Output = Prebooking;

export default function useGetPrebookingMe (
  prebookingInternalId: string | undefined,
  options?: CacheQueryOpts
): CacheQueryOutput<Output> {
  const client = useAPIClient(ME_BASE_URL);
  return useCacheQuery<Output>(
    ["prebooking-by-internal-id", prebookingInternalId],
    () => {
      if (!prebookingInternalId) {
        throw new Error('Error getting prebooking ID');
      }

      return client.get<any>(`prebookings/` + prebookingInternalId);
    },
    options
  );
}